'use strict';

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Message", "DropZone");

var clipboardObj = null;

module.exports = exports.default = function () {
    if (clipboardObj != null) {
        clipboardObj.destroy();
    }
    clipboardObj = new _clipboard2.default("[data-copy-to-clipboard]", {
        text: function text(trigger) {
            _notify2.default.success(Resx.DropZone('CopiedToClipboard')); // Zkopírováno do schránky.
            return $(trigger).attr("data-copy-to-clipboard");
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/clipboard.js
// module id = 416
// module chunks = 0